var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobdescicone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4L18 11L14 15",
    stroke: "#E54545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18L2.768 16.232M2.828 16.172C3.09062 16.4347 3.40241 16.6431 3.74557 16.7853C4.08874 16.9274 4.45655 17.0006 4.828 17.0006C5.19945 17.0006 5.56726 16.9274 5.91043 16.7853C6.25359 16.6431 6.56538 16.4347 6.828 16.172L17.414 5.58601C17.5998 5.40028 17.7472 5.17977 17.8478 4.93707C17.9483 4.69436 18.0001 4.43422 18.0001 4.17151C18.0001 3.9088 17.9483 3.64866 17.8478 3.40596C17.7472 3.16325 17.5998 2.94274 17.414 2.75701L16.243 1.58601C16.0573 1.40021 15.8368 1.25282 15.5941 1.15226C15.3513 1.0517 15.0912 0.999939 14.8285 0.999939C14.5658 0.999939 14.3057 1.0517 14.0629 1.15226C13.8202 1.25282 13.5997 1.40021 13.414 1.58601L2.828 12.172C2.56531 12.4346 2.35692 12.7464 2.21475 13.0896C2.07257 13.4328 1.9994 13.8006 1.9994 14.172C1.9994 14.5435 2.07257 14.9113 2.21475 15.2544C2.35692 15.5976 2.56531 15.9094 2.828 16.172Z",
    stroke: "#E54545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobdescicone);
export default __webpack_public_path__ + "static/media/jobdescicone.5d412104d68bf22270602e461b3dee78.svg";
export { ForwardRef as ReactComponent };